function init_gamememorysummer(from_php){
    
    init_gamememory(from_php);
}